import { ParagraphText, UBButton } from "../../../../Libraries";
import OrderCalculation from "../OrderCalculation";
import useSort from "../../../../hooks/useSort";
import {
  InnerWrapper,
  MainContainer,
  TitleAndActionBox,
} from "../../../common";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { analytics, triggerLogEvent } from "../../../../config/firebase";
import HeaderItem from "./HeaderItem";
import ListItem from "./ListItem";
import {
  AIRWAY_BILL_INVOICE,
  PATCH_ACCEPT_REJECT_ORDER,
  PUT_UPDATE_ORDER,
} from "../../../../apis/configuration";
import {
  OrderRejectModal,
  EditOrderModal,
  OrderShipModal,
} from "../../../common/Modals";
import { Box, Grid } from "@mui/material";
import {
  DIMENSION_TYPES,
  PARCEL_TYPES,
  sentenceCase,
  WEIGHT_TYPES,
} from "../../../../constants";
import { handleApi } from "../../../../apis";
import fileDownload from "js-file-download";
import ConfirmationModal from "../../../common/Modals/ConfirmationModal";
import styles from "./styles.module.css";

const OrderDetail = ({ data, navigate }) => {
  const { handleOrderStatus, rejectReasons, updateLoad, order, I18n } =
    data || {};

  const {
    order_status,
    order_number,
    order_detail,
    tracking_id,
    order_date,
    id,
  } = order || {};
  const { sort } = useSort() || {};
  const [rejectReason, setRejectReason] = useState({ other: "", reason: "" });
  const [toggle, setToggle] = useState({ type: "", toggle: false });
  const [disableUpdate, setDisableUpdate] = useState(true);
  const [rejectModal, setRejectModal] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [updatedItems, setUpdatedItems] = useState({});
  const [printLoad, setPrintLoad] = useState(false);
  const [shipModal, setShipModal] = useState(false);
  const [shipParcel, setShipParcel] = useState({
    parcel_type: "",
    weight: { value: "", unit: "Kg" },
    dimensions: { unit: "Inch" },
  });
  const [note, setNote] = useState(order.note);
  const [disabled, setDisabled] = useState(false);

  const isValidationForm = (item) => {
    return item.parcel_type === "Flyer"
      ? +item.weight.value && item.weight.unit
      : item.parcel_type === "Carton"
        ? +item.weight.value &&
          item.weight.unit &&
          +item.dimensions.length &&
          +item.dimensions.width &&
          +item.dimensions.height &&
          item.dimensions.unit
        : false;
  };
  /**
   * Receive params of type to handle acccept or reject order and toogle to toggle mdoal
   * @returns toggle modal based on type;
   */
  const toggleOrderModal = (type = "", toggle = false) =>
    setToggle({ type, toggle });

  /**
   * Receive toggle to toggle reject order modal
   * @returns toggle modal;
   */
  const toggleRejectModal = (toggle = false) => setRejectModal(toggle);

  /**
   * Receive toggle to toggle ship order modal
   * @returns toggle modal;
   */
  const toggleShipModal = () => setShipModal(!shipModal);

  /**
   * Receive toggle to toggle update order modal,
   * scroll modal to bottom & disable button
   * @returns toggle modal;
   */
  const toggleUpdateModal = (toggle = false) => {
    setUpdateModal(toggle);
    setDisableUpdate(true);

    if (toggle) {
      setTimeout(() => {
        try {
          document
            .getElementById("editButton")
            .scrollIntoView({ behavior: "smooth" });
        } catch {}
      }, 100);
    }
  };

  /**
   * Receive key to change specific field value by params (value)
   * @returns update specific state;
   */
  const onChangeText = (key, value) => {
    if (key == I18n.enter_reason_here)
      setRejectReason({ ...rejectReason, other: value });
    else if (key == I18n.select_reason)
      setRejectReason({ reason: value.reason });
    else if (key == I18n.add_note_to_the_order) {
      setNote(value);
      if (disableUpdate) setDisableUpdate(false);
    } else if (key == I18n.select_parcel_type)
      setShipParcel((e) => {
        setDisabled(isValidationForm({ ...e, parcel_type: value }));
        resetShipParcel(value);
        return { ...e, parcel_type: value };
      });
    else if (key == I18n.weight_type)
      setShipParcel((e) => {
        setDisabled(
          isValidationForm({ ...e, weight: { ...e.weight, unit: value } }),
        );
        return { ...e, weight: { ...e.weight, unit: value } };
      });
    else if (key == I18n.enter_weight)
      setShipParcel((e) => {
        if (value < 0) return { ...e };
        setDisabled(isValidationForm({ ...e, weight: { ...e.weight, value } }));
        return { ...e, weight: { ...e.weight, value: value ? +value : "" } };
      });
    else if (key == I18n.select_dimensions)
      setShipParcel((e) => {
        const [length, width, height] = value ? value.split(" x ") : [];
        setDisabled(
          isValidationForm({
            ...e,
            dimensions: {
              ...e.dimensions,
              length: +length,
              width: +width,
              height: +height,
            },
          }),
        );
        return {
          ...e,
          dimensions: {
            ...e.dimensions,
            length: +length,
            width: +width,
            height: +height,
          },
        };
      });
  };
  const resetShipParcel = (parcel_type) => {
    setShipParcel({
      parcel_type: parcel_type,
      weight: { value: "", unit: "Kg" },
      dimensions: { unit: "Inch" },
    });
  };

  /**
   * Toggle reject modal or calling api to accept order
   * @returns toggle modal and update order
   */
  const handleOrder = () => {
    if (toggle.type == "reject") {
      toggleRejectModal(true);
      toggleOrderModal();
    } else {
      let params = { id };

      if (toggle.type == "accept") params["accept"] = true;
      else {
        params["ready_to_ship"] = true;
        params["parcel_type"] = PARCEL_TYPES[shipParcel.parcel_type].type;
        if (shipParcel.parcel_type === "Carton") {
          let weight = { ...shipParcel.weight };
          let dimensions = { ...shipParcel.dimensions };
          weight.unit = WEIGHT_TYPES[weight.unit].type;
          dimensions.unit = DIMENSION_TYPES[dimensions.unit].type;
          params["weight"] = weight;
          params["dimensions"] = dimensions;
        } else {
          let weight = { ...shipParcel.weight };
          weight.unit = WEIGHT_TYPES[weight.unit].type;
          params["weight"] = weight;
        }
      }
      handleOrderStatus(PATCH_ACCEPT_REJECT_ORDER, params, true).then(() => {
        toggleOrderModal();
        toggleShipModal();
        setShipParcel({
          parcel_type: "",
          weight: { value: "", unit: "Kg" },
          dimensions: { unit: "Inch" },
        });
        toast.success(
          toggle.type == "accept"
            ? "Order accepted successfully"
            : "Order has been marked as ready to shipped",
          { className: "successToast" },
        );
      });
    }
  };

  /**
   * calling api to reject order
   * @returns update order
   */
  const handleRejectOrder = () =>
    handleOrderStatus(
      PATCH_ACCEPT_REJECT_ORDER,
      { reason: rejectReason.other || rejectReason.reason, reject: true, id },
      true,
    ).then(() => {
      toggleRejectModal();
      toast.success("Order rejected successfully", {
        className: "successToast",
      });
    });

  /**
   * calling api to download receipt
   * @returns pdf
   */
  const downloadReceipt = () => {
    setPrintLoad(true);
    let params = { order_ids: [id] };
    handleApi(AIRWAY_BILL_INVOICE, params, null, navigate,null, { responseType: "blob" })
      .then((res) => {
        fileDownload(res, "Airways.pdf");
        toast.success("PDF downloaded successfully", {
          className: "successToast",
        });
      })
      .catch((err) =>
        toast.error(err?.response?.data?.message || "Something went wrong", {
          className: "errorToast",
        }),
      )
      .finally(() => setPrintLoad(false));
  };

  /**
   * calling api to update order
   * @returns update order
   */
  const handleUpdateOrder = () => {
    let params = {
      note,
      id,
    };

    order_detail.map((item) => {
      const { id, allocated_qty } = item || {};
      if (allocated_qty != updatedItems[item.id].allocated_qty) {
        let obj = {
          id,
          allocated_qty: Number(updatedItems[item.id].allocated_qty),
        };

        if (params["order_data"]) params.order_data.push(obj);
        else params["order_data"] = [obj];
      }
    });

    handleOrderStatus(PUT_UPDATE_ORDER, params, true).then(() => {
      toggleUpdateModal();
      toast.success(
        params?.order_data
          ? "Order updated successfully"
          : "Order note updated successfully",
        { className: "successToast" },
      );
    });
  };

  let RightItem = [
    {
      id: "order_detail_edit_btn",
      action: () => {
        triggerLogEvent(analytics, "sc_order_detail_action", {
          action: "edit",
          order_number,
        });
        toggleUpdateModal(true);
      },
      className: "marginLeft15 ubSecondaryButton",
      title: `${I18n.edit} ${I18n.order}`,
      style: {
        height: "34px",
        minWidth: "105px",
      },
    },
    {
      id: "order_detail_reject_btn",
      action: () => {
        triggerLogEvent(analytics, "sc_order_detail_action", {
          action: "reject",
          order_number,
        });
        toggleOrderModal("reject", true);
      },
      className: "marginLeft15 ubSecondaryButton",
      title: `${I18n.reject} ${I18n.order}`,
      style: {
        height: "34px",
        minWidth: "105px",
      },
    },
    {
      id: "order_detail_action_btn",
      action: () => {
        if (order_status == "accepted") {
          triggerLogEvent(analytics, "sc_order_detail_action", {
            action: "ready_to_ship",
            order_number,
          });
          toggleShipModal(true);
        } else {
          triggerLogEvent(analytics, "sc_order_detail_action", {
            action: "accept",
            order_number,
          });
          toggleOrderModal("accept", true);
        }
      },
      title:
        order_status == "accepted"
          ? `${I18n.ready_to_ship} ${I18n.order}`
          : `${I18n.accept_small} ${I18n.order}`,
      className: "marginLeft15 ubPrimaryButton",
      style: {
        height: "34px",
        minWidth: "105px",
      },
    },
  ];

  const RightItemButton =
    order_status == "pending"
      ? RightItem
      : order_status == "pending_on_customer"
        ? [RightItem[0], RightItem[1]]
        : order_status == "accepted"
          ? [RightItem[2]]
          : tracking_id
            ? [
                {
                  id: "order_detail_print_label_btn",
                  action: () => {
                    triggerLogEvent(analytics, "sc_order_detail_action", {
                      action: "print_label",
                      order_number,
                    });
                    downloadReceipt();
                  },
                  className: "printButton marginLeft15 ubSecondaryButton",
                  title: I18n.print_bill,
                  disabled: printLoad,
                  loading: printLoad,
                  style: {
                    height: "34px",
                    minWidth: "105px",
                  },
                },
              ]
            : [];

  return (
    <MainContainer fluid>
      <Grid container>
        <Grid item md={12}>
          <TitleAndActionBox
            data={{
              title: (
                <ParagraphText>
                  {`${I18n.order_number} # ${order_number} `}
                </ParagraphText>
              ),
              isBack: true,
              isTitleCase: false,
            }}
          >
            {RightItemButton?.length > 0
              ? RightItemButton.map((item, index) => {
                  return (
                    <UBButton
                      id={item.id}
                      title={item.title}
                      className={item.className}
                      style={item.style}
                      onClick={item.action}
                      key={`key-${index}`}
                    />
                  );
                })
              : null}
          </TitleAndActionBox>
          <InnerWrapper
            className={`innerWrapper newInnerWrapper orderManagementWrapper ${styles.orderDetailWrapper}`}
          >
            <>
              <div className="orderDetailInnerBox">
                <div className="orderDetailInnerBoxLeft">
                  <HeaderItem I18n={I18n} />
                  <div className="orderDetailItemList">
                    {sort(order_detail)?.map((item, index) => (
                      <ListItem item={item} key={index} />
                    ))}
                  </div>
                </div>
                <div className="orderDetailInnerBoxRight">
                  <div className="orderDetailCalculationBox">
                    <Box className={styles.orderDetailheader}>
                      <ParagraphText
                        className={"fontSize14 fontWeight500 newFontColor"}
                      >
                        {I18n.order_summary}
                      </ParagraphText>
                    </Box>
                    <OrderCalculation I18n={I18n} order={order} />
                  </div>

                  {/* <CustomerDetails I18n={I18n} order={order} /> */}
                </div>
              </div>

              <ConfirmationModal
                open={toggle.toggle}
                onClose={() => toggleOrderModal()}
                onConfirm={handleOrder}
                message={`${I18n.are_you_sure} ${
                  toggle.type == "reject"
                    ? I18n.you_want_to_reject_this_order
                    : toggle.type == "accept"
                      ? I18n.you_want_to_confirm_order
                      : I18n.you_want_to_ship_this_order
                }`}
                title={sentenceCase(
                  `${I18n.order_number} # ${order_number} ${I18n.confirmation}`,
                )}
                confirmText={
                  toggle.type == "reject"
                    ? `${I18n.reject} ${I18n.order}`
                    : toggle.type == "accept"
                      ? `${I18n.accept} ${I18n.order}`
                      : toggle.type == "ready_to_ship"
                        ? I18n.ready_to_ship
                        : ""
                }
                cancelText={I18n.back}
                id="order_modal"
                confirmButtonClassName="ubPrimaryButton"
              />

              <OrderRejectModal
                header={{ title: "please_share_ur_reason" }}
                body={{
                  title: I18n.select_reason,
                  toggle: rejectModal,
                  toggleRejectModal,
                  rejectReasons,
                  onChangeText,
                  rejectReason,
                  I18n,
                }}
                footer={[
                  {
                    data: {
                      className: "ubSecondaryButton",
                      title: I18n.cancel,
                      onClick: () => toggleRejectModal(),
                      id: `rejected_cancel`,
                    },
                  },
                  {
                    data: {
                      disabled: !(rejectReason.reason == "Other"
                        ? rejectReason.other
                        : rejectReason.reason),
                      className: "ubPrimaryButton",
                      title: I18n.save,
                      onClick: handleRejectOrder,
                      id: `rejected_confirm`,
                    },
                  },
                ]}
              />
              <EditOrderModal
                header={{ updateLoad, title: "edit_item_quantity" }}
                body={{
                  orderDetail: order_detail,
                  toggle: updateModal,
                  toggleUpdateModal,
                  setDisableUpdate,
                  setUpdatedItems,
                  disableUpdate,
                  updatedItems,
                  onChangeText,
                  note,
                  I18n,
                }}
                footer={[
                  {
                    data: {
                      className: "ubSecondaryButton",
                      title: I18n.cancel,
                      onClick: () => toggleUpdateModal(),
                      id: `${id}_cancel`,
                    },
                  },
                  {
                    data: {
                      className: "ubPrimaryButton",
                      title: I18n.update,
                      onClick: handleUpdateOrder,
                      loading: updateLoad,
                      disabled: disableUpdate,
                      id: `${id}_confirm`,
                    },
                  },
                ]}
              />
              <OrderShipModal
                headerTitle={I18n.ready_to_ship}
                body={{
                  title: I18n.select_parcel_type,
                  toggle: shipModal,
                  toggleShipModal,
                  onChangeText,
                  shipParcel,
                }}
                footer={[
                  {
                    data: {
                      title: I18n.back,
                      onClick: toggleShipModal,
                      className: "ubSecondaryButton",
                      id: "ship_order_id",
                    },
                  },
                  {
                    data: {
                      disabled: !Boolean(disabled),
                      title: I18n.ship_order,
                      onClick: handleOrder,
                      className: "ubPrimaryButton",
                      id: "ship_order_id",
                    },
                  },
                ]}
              />
            </>
          </InnerWrapper>
        </Grid>
      </Grid>
    </MainContainer>
  );
};

export default OrderDetail;
